import { motion } from "framer-motion";
import MovingBackground from "./MovingBackground";
import logoIcon from "@/assets/logo-icon.png";

const ease = [0.16, 1, 0.3, 1] as const;

const TitleSlide = ({ thumbnail }: { thumbnail?: boolean }) => {
  const content = (
    <div className="relative w-full h-full flex flex-col items-center justify-center bg-background overflow-hidden">
      <MovingBackground variant="orbs" />

      <div className="relative z-10 flex flex-col items-center text-center px-8 max-w-4xl">
        <motion.img
          src={logoIcon}
          alt="EastWest IT"
          className="w-16 h-16 mb-6"
          initial={thumbnail ? false : { scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ duration: 0.8, ease }}
        />

        <motion.div
          className="label-text mb-4"
          initial={thumbnail ? false : { opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6, ease }}
        >
          AI‑Ready Microsoft 365 Advisor
        </motion.div>

        <motion.h1
          className="font-display font-bold text-foreground leading-tight mb-6"
          style={{ fontSize: thumbnail ? "1.2rem" : "clamp(2rem, 5vw, 4.5rem)" }}
          initial={thumbnail ? false : { opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.7, ease }}
        >
          Copilot & AI Agents,{" "}
          <span className="text-gradient">Governed & Secure</span>
        </motion.h1>

        <motion.p
          className="text-muted-foreground font-body max-w-2xl leading-relaxed"
          style={{ fontSize: thumbnail ? "0.6rem" : "clamp(0.9rem, 1.5vw, 1.25rem)" }}
          initial={thumbnail ? false : { opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.6, ease }}
        >
          Helping organisations turn Microsoft 365 Copilot and AI agents into a governed, secure and value‑creating capability.
        </motion.p>
      </div>
    </div>
  );

  return content;
};

export default TitleSlide;
